import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConfirmModalConfig } from '../../../shared/models/confirmModalConfig';
import { EntityConfig } from '../actions/entity-config.action';

export interface FeatureState {
  entityConfig: EntityConfig;
}

export const entityConfig = createFeatureSelector('entityConfig');

export const getEntityConfig =  createSelector(
  entityConfig,
  (state: FeatureState) => state.entityConfig
);

export const selectSingleApprover = createSelector(
    entityConfig,
    (state: FeatureState) => !state.entityConfig['single-approver']
);

/* Creating a selector that will return the state of the modal. */
export const selectConfig = createFeatureSelector<ConfirmModalConfig>('config');

/* Creating a selector that will return the state of the modal. */
export const selectModalState = createSelector(
  selectConfig,
  (config) => config.modalState
);

/* Creating a selector that will return the entire config object. */
export const selectModalConfig = createSelector(
  selectConfig,
  (config) => config
);

/* Creating a selector that will return the callback type. */
export const selectModalCallback = createSelector(
  selectConfig,
  (config) => config.callBackType
);

/* Creating a selector that will return the deployState of the modal. */
export const selectModalDeployState = createSelector(
  selectConfig,
  (config) => config.deployState
);

